<div>
	<nb-badge
		class="color"
		position="relative"
		[style.background]="rowData.color"
		[style.color]="backgroundContrast(rowData.color)"
		text="{{ rowData.name }}"
	>
	</nb-badge>
</div>
